export default {
      id: "sliders-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#sliders",
      toString: function () {
        return this.url;
      }
    }